<form [formGroup]="pricingFormGroup">
  <div class="product-detail-container">
    <div class="product-details-left">
      <h6>Cost Price (Optional)</h6>
      <div class="flex">
        <h6 class="peso-sign">₱</h6>
        <mat-form-field appearance="fill" class="w-full">
          <input
            matInput
            formControlName="CostPrice"
            type="number"
            placeholder="0.00"
          />
          <mat-hint>Enter this value to calculate your profit</mat-hint>
        </mat-form-field>
      </div>

      <h6>Selling Price*</h6>
      <div class="flex">
        <h6 class="peso-sign">₱</h6>
        <mat-form-field appearance="fill" class="w-full">
          <input
            matInput
            formControlName="SellingPrice"
            placeholder="0.00"
            type="number"
            [value]="sellingPrice"
            required
          />
          <mat-hint>Enter this value to calculate your profit</mat-hint>
          <mat-error
            *ngIf="pricingFormGroup.get('SellingPrice')?.hasError('required') && pricingFormGroup.get('SellingPrice')?.touched"
          >
            Selling Price is Required
          </mat-error>
        </mat-form-field>
      </div>

      <mat-radio-group
        formControlName="IsVatable"
        class="flex flex-column"
        [(ngModel)]="selectedVat"
        (change)="selectVat()"
      >
        <mat-radio-button color="primary" [value]="true">
          Includes Vat
        </mat-radio-button>
        <mat-radio-button color="primary" [value]="false"
          >This product does not have VAT</mat-radio-button
        >
      </mat-radio-group>

      <h6>VAT Amount*</h6>
      <div class="flex">
        <h6 class="peso-sign">₱</h6>
        <mat-form-field appearance="fill" class="w-full">
          <input
            matInput
            formControlName="VatAmount"
            placeholder="0.00"
            required
            [value]="vatAmount"
            type="number"
          />
          <mat-hint
            >Active form labels with an asterisk (*) are required.</mat-hint
          >
          <mat-error
            *ngIf="pricingFormGroup.get('VatAmount')?.hasError('required') && pricingFormGroup.get('VatAmount')?.touched"
          >
            Vat amount is Required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
    <div class="product-details-right">
      <h6>Displayed Price</h6>
      <div class="flex">
        <h6 class="peso-sign">₱</h6>
        <mat-form-field appearance="fill" class="w-full">
          <input
            matInput
            formControlName="DisplayedPrice"
            placeholder="0.00"
            type="number"
            [value]="displayPrice"
            required
          />
          <mat-hint
            >The price shown to customers in the Xpress app. This value is
            automatically calculated.</mat-hint
          >
          <mat-error
            *ngIf="pricingFormGroup.get('DisplayedPrice')?.hasError('required') && pricingFormGroup.get('DisplayedPrice')?.touched"
          >
            Display Price is Required
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
</form>
